import { useState, useEffect } from 'react';
import customHeaders, { getSpace } from '../../../../common/headers';
import useGeneralStore from '../../../../store/general';
import { HistoryItem } from '../../../CreateCampaignFromRules/Modal/ModalHistoryActions/HistoryItem/HistoryItem';
import { useResponseHandler } from '../../../../common/auth';
import { ModalComponent } from '../../../../components/Modal/ModalComponent/ModalComponent';
import './ModalHistoryActions.scss'

const ModalHistoryActions = ({ setIsModal, uid }) => {

    const selectedSpace = useGeneralStore((state) => state.selectedSpace);
    const headers = { ...customHeaders, ...getSpace(selectedSpace) };
    const { handleTableResponse, handleRequestError } = useResponseHandler();
    const [loading, setLoading] = useState(false)
    const [logsArr, setLogsArr] = useState(null)

    // Получение логов
    const fetchGetLog = () => {
        setLoading(true);
        let url = `https://apps1.ecomru.ru:4450/api/v1/strategies/history`

        const body = JSON.stringify({
            page: 1,
            limit: 10000,
            uid: uid
        })

        fetch(url, { body, method: 'POST', headers })
            .then(handleTableResponse)
            .then((json) => setLogsArr(json))
            .catch(handleRequestError)
            .finally(() => setLoading(false));
    };


    useEffect(() => {
        fetchGetLog()
    }, []);

    return (
        <ModalComponent
            title='История изменений'
            onClose={e => setIsModal(false)}
            loading={loading}
            style={{
                maxWidth: '500px'
            }}
            isNoData={!logsArr?.length}
            child={
                <div className='modal-history-actions-v2'>
                    {logsArr?.length
                        ?
                        <div className='modal-history-actions-v2__content'>
                            {logsArr?.map((el) => (
                                <HistoryItem
                                    key={el.comment + el.timestamp}
                                    {...el}
                                />
                            ))}
                        </div> : null}
                </div>
            }
        />
    )
}

export { ModalHistoryActions }